<h2>
    {{ listOfProvisionsTitle }}
</h2>

<br>
  
  <!-- <ag-grid-angular
      style="width: 100%; height: 500px;"
      class="ag-theme-balham"
      
      [rowData]="listOfProvisions"
      [columnDefs]="defaultUserViewCols"
      [enableCellTextSelection]="true"
      (gridReady)="onGridReady($event)"
      >
  </ag-grid-angular> -->


  <!-- (cellClicked)='onCellClicked($event)' -->
